import { ZensierteErfindungEntry } from '../model/zensierte-erfindung';
import { DataFetcher } from './fetcher/DataFetcher';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface ZensierteErfindungSearchParams extends AbstractSearchParams {
  country?: string;
  field?: string;
  title?: string;
}

export class ZensierteErfindungRepository extends RepositoryNocoDbBase<
  ZensierteErfindungEntry,
  ZensierteErfindungSearchParams
> {
  protected readonly TABLE_NAME = 'erfindungen';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'CreatedAt' as const;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS = ['country', 'field'];

  protected readonly EQUAL_FILTERS = ['country', 'field'];

  protected readonly SEARCH_FIELDS: (keyof ZensierteErfindungEntry)[] = [
    'title',
    'inventor',
    'invention',
    'censorship',
    'country',
    'field',
    'suppression',
    'year'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
